export { version, packageName, repositoryOwner, repositoryName } from '../../version.ts';
